import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState
} from './workflow-settings.action';
import { WorkflowSettings } from './workflow-settings.model';

export interface WorkflowSettingsRecordsState {
    listData: WorkflowSettings[];
    singleData: WorkflowSettings;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: WorkflowSettingsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const WorkflowSettingsRecordReducer = createReducer(

    initialState,

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);